import { Field, Label, Select, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { useGetTiltakskategorier } from '../../../../../../components/tiltakSection/tiltakForm/useGetTiltakskategorier';
import { EnergiObjektType } from '../../../../../../utils/matrikkelBygningsTyper';
import { camelCasify } from '../../../../../../utils/navigation';
import { useTiltakFormContext } from '../utils';

export const KategoriSelect = ({ energiobjekttype }: { energiobjekttype: EnergiObjektType }) => {
  const { register, formState } = useTiltakFormContext();
  const { t } = useTranslation();
  const { tiltakskategorier } = useGetTiltakskategorier(energiobjekttype as EnergiObjektType);
  const error = formState.errors.kategori?.message;
  const kategorier = tiltakskategorier?.map(({ kategori }) => kategori) || [];

  return (
    <Field>
      <Label htmlFor="kategori">{t('screens.energiplan.components.tiltakForm.kategoriSelect.label')}</Label>
      <Select
        id="kategori"
        aria-invalid={!!error}
        defaultValue=""
        width="full"
        {...register('kategori', {
          required: t('screens.energiplan.components.tiltakForm.kategoriSelect.required')
        })}
      >
        <Select.Option disabled value="">
          {t('screens.energiplan.components.tiltakForm.kategoriSelect.placeholder')}
        </Select.Option>
        {kategorier.map((kategori) => (
          <Select.Option key={kategori} value={kategori}>
            {t(`tiltak.category.${camelCasify(kategori)}`)}
          </Select.Option>
        ))}
      </Select>
      {error && <ValidationMessage data-color="danger">{error}</ValidationMessage>}
    </Field>
  );
};
